import { AfterViewInit, Directive, ElementRef, Input, OnChanges } from '@angular/core';

import { SubmissionStatus } from '../../core';

@Directive({
  selector: '[scipSubmissionStatus]'
})
export class SubmissionStatusDirective implements AfterViewInit, OnChanges {
  @Input() scipSubmissionStatus: string;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    // Needs to be done here because the input is not set in the constructor/onInit
    this.checkForStatus();
  }
  ngOnChanges(): void {
    //Checking the status has to be repeated to make sure new Input changes the label accordingly
    this.checkForStatus();
  }

  private checkForStatus(): void {
    switch (this.scipSubmissionStatus) {
      case SubmissionStatus.VALIDATION_FAILED:
      case SubmissionStatus.FAILED:
      case SubmissionStatus.ONE_OR_MORE_FAILED:
      case SubmissionStatus.DOSSIER_TOO_LARGE: {
        this.el.nativeElement.style.color = '#CC0000';
        break;
      }
      default: {
        this.el.nativeElement.style.color = '#333333';
        break;
      }
    }
  }
}
